import { queryClient } from "@/queryClient";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/identity-and-access/groups/")({
  staticData: {
    title: "groups.title",
  },
  loader: () => {
    // TODO: Make sure loginAnswer is available in loader
    // if (!getModuleRights("Tags").view) {
    //   throw redirect({ to: "/", replace: true });
    // }

    const stored = window.localStorage.getItem("companyId");
    if (!stored) {
      throw new Error("Missing companyId in localStorage");
    }
    const companyId = Number(stored);

    return import("@/modules/identity-and-access/groups/services/queries").then(({ queries }) =>
      queryClient.ensureQueryData(queries(companyId).getGroups),
    );
  },
});
